<template>
  <footer class="relative mt-auto border-t border-surface-200/50 dark:border-surface-800/50 transition-colors duration-300">
    <!-- Subtle gradient top border -->
    <div class="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-500/20 to-transparent"></div>

    <div class="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
        <!-- Brand Column -->
        <div class="flex flex-col items-center md:items-start gap-5">
          <img src="../assets/companyLogo.png" alt="Neutral Fuels" class="h-10 w-auto opacity-80 dark:opacity-60" />
          <div class="flex items-center gap-4">
            <img src="../assets/icv.png" alt="ICV Certified" class="h-8 w-auto opacity-60 dark:opacity-40 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
            <img src="../assets/netzero.png" alt="Net Zero" class="h-8 w-auto opacity-60 dark:opacity-40 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
          </div>
        </div>

        <!-- Legal Links -->
        <div class="flex flex-col items-center md:items-start gap-3">
          <h3 class="text-xs font-semibold text-surface-400 dark:text-surface-600 uppercase tracking-widest mb-1">
            Legal
          </h3>
          <router-link
            to="/terms-and-conditions"
            class="text-sm text-surface-500 dark:text-surface-500 hover:text-accent-600 dark:hover:text-accent-400 transition-colors duration-200"
          >
            Terms and Conditions
          </router-link>
          <router-link
            to="/privacy-policy"
            class="text-sm text-surface-500 dark:text-surface-500 hover:text-accent-600 dark:hover:text-accent-400 transition-colors duration-200"
          >
            Privacy Policy
          </router-link>
          <router-link
            to="/cookies-policy"
            class="text-sm text-surface-500 dark:text-surface-500 hover:text-accent-600 dark:hover:text-accent-400 transition-colors duration-200"
          >
            Cookies Policy
          </router-link>
        </div>

        <!-- Contact -->
        <div class="flex flex-col items-center md:items-start gap-2">
          <h3 class="text-xs font-semibold text-surface-400 dark:text-surface-600 uppercase tracking-widest mb-1">
            Contact
          </h3>
          <p class="text-sm text-surface-500 dark:text-surface-500">Neutral Fuels LLC</p>
          <p class="text-sm text-surface-500 dark:text-surface-500 leading-relaxed">
            Suite 415, Liberty House<br />
            DIFC, Dubai
          </p>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="mt-10 pt-6 border-t border-surface-200/50 dark:border-surface-800/50">
        <div class="flex flex-col md:flex-row justify-between items-center gap-3">
          <p class="text-xs text-surface-400 dark:text-surface-600 text-center md:text-left">
            &copy; {{ currentYear }} The Neutral Fuels Group of Companies. All rights reserved.
          </p>
          <p class="text-xs font-mono text-surface-400 dark:text-surface-600">
            {{ versionNumber }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const versionNumber = computed(() => store.state.versionNumber)
const currentYear = new Date().getFullYear()
</script>
